import { types, flow, applySnapshot } from "mobx-state-tree";
import { v4 as uuidv4 } from "uuid";

import { Outlet, Product, Client } from "./common";
import { URL_API } from "./globals";

const ItemMatrix = types
  .model("ItemMatrix", {
    uuid: types.optional(types.identifier, () => uuidv4()),
    outlet: types.reference(Outlet),
    product: types.reference(Product),
    selected: types.optional(types.boolean, false),
    order: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setSelected(selected) {
      self.selected = selected;
    },
  }));

const ItemOutletcolMatrix = types.model("ItemMatrix", {
  outlet: types.reference(Outlet),
  column: types.number,
});

const MatrixStore = types
  .model("MatrixStore", {
    matrix: types.optional(types.array(ItemMatrix), []),
    outlets: types.optional(types.array(types.reference(Outlet)), []),
    curOutlets: types.optional(types.array(ItemOutletcolMatrix), []),
    products: types.optional(types.array(types.reference(Product)), []),
    currentClient: types.optional(types.string, ""),
    selectClient: types.optional(types.string, ""),
    selectKind: types.optional(types.string, ""),
    mod: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setMod() {
      self.mod = !self.mod;
    },
    clearCurOutlets() {
      self.curOutlets.clear();
    },
    addCurOutlets(outlet, column) {
      self.curOutlets.push({ outlet, column });
    },
    setSelectClient(selectClient = null) {
      self.selectClient = selectClient;
    },
    setSelectKind(selectKind = null) {
      self.selectKind = selectKind;
    },
    getFetchMatrix: flow(function* () {
      try {
        if (self.selectClient) {
          const response = yield fetch(`${URL_API}/api/getmatrix`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              data: { client: self.selectClient, kind: self.selectKind },
            }),
          });
          const json = yield response.json();

          applySnapshot(self, {
            matrix: json.data.matrix,
            outlets: json.data.outlets.map((item) => item.uuid),
            products: json.data.products.map((item) => item.uuid),
            selectClient: self.selectClient,
            selectKind: self.selectKind,
          });
          self.setCurrentClient(self.selectClient + self.selectKind);
        } else {
          applySnapshot(self, {
            matrix: [],
            outlets: [],
            products: [],
            selectClient: self.selectClient,
            selectKind: self.selectKind,
          });
          self.setCurrentClient(self.selectClient + self.selectKind);
        }
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
    getFetchProductsgetByClient: flow(function* () {
      try {
        if (self.selectClient) {
          const response = yield fetch(
            `${URL_API}/api/getProductsgetByClient`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                data: { client: self.selectClient },
              }),
            }
          );
          const json = yield response.json();

          const { data } = json;

          self.products.forEach((item) => {
            const cur = data.find((it) => it.product === item.uuid);

            if (cur) {
              item.set(cur);
            }
          });
        }
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
    getSaveMatrix: flow(function* () {
      try {
        const response = yield fetch(`${URL_API}/api/savematrix`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: self.matrix,
          }),
        });
        const json = yield response.json();
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
    addMatrix(value) {
      self.matrix = value;
    },
    addItem(item) {
      self.matrix.push(item);
    },
    clearMatrix() {
      self.matrix.clear();
    },
    setCurrentClient(client) {
      self.currentClient = client;
    },
  }));

export default MatrixStore;
